import {NavLink} from 'react-router-dom';
import {useCustomers} from '../../../customers';
import {Customer} from '../../../customers/types';
import {
    Group,
    Paper,
    Stack,
    Table,
    Text,
    Title,
    Button,
} from '@mantine/core';

export const RecentCustomersWidget = () => {

    const {items, loading} = useCustomers();

    return (
        <Paper shadow="sm" p="lg" radius="md" withBorder>
            <Stack gap="md">
                <Group justify="space-between">
                    <Title order={5}>Recent Customers</Title>
                    <Button variant="subtle" size="xs" component={NavLink} to="/customers">
                        View All
                    </Button>
                </Group>

                {loading ? (
                    <Text size="sm" c="dimmed">Loading...</Text>
                ) : items.length === 0 ? (
                    <Text size="sm" c="dimmed">No customers yet</Text>
                ) : (
                    <Table verticalSpacing="xs" highlightOnHover>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Name</Table.Th>
                                <Table.Th>Email</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {items.map((item: Customer) => (
                                <Table.Tr key={item.id}>
                                    <Table.Td>
                                        <NavLink to={`/customers/${item.id}`}>
                                            <Text size="sm">{item.name || item.id}</Text>
                                        </NavLink>
                                    </Table.Td>
                                    <Table.Td>
                                        <Text size="sm" c="dimmed">{item.email || '-'}</Text>
                                    </Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                )}
            </Stack>
        </Paper>
    );
};
